(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Glyph", [], factory);
	else if(typeof exports === 'object')
		exports["Glyph"] = factory();
	else
		root["Glyph"] = factory();
})(this, function() {
return 